import { render, staticRenderFns } from "./ClassManage.vue?vue&type=template&id=77dc1ed6&"
import script from "./ClassManage.vue?vue&type=script&lang=js&"
export * from "./ClassManage.vue?vue&type=script&lang=js&"
import style0 from "./ClassManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports